export default function data( state = {
  locations: {nodes:[]},
}, action ) {
  switch ( action.type ) {
    case 'LOAD_LOCATIONS':
      return {
        ...state,
        locations: action.data,
      };
    default:
      return state;
  }
}